var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#767676",
    stroke: "#767676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.167 7.66675H11.8337C9.53247 7.66675 7.66699 9.53223 7.66699 11.8334V20.1667C7.66699 22.4679 9.53247 24.3334 11.8337 24.3334H20.167C22.4682 24.3334 24.3337 22.4679 24.3337 20.1667V11.8334C24.3337 9.53223 22.4682 7.66675 20.167 7.66675Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 15.475C19.4366 16.1685 19.3181 16.8769 18.9952 17.4992C18.6723 18.1215 18.1614 18.6262 17.5351 18.9414C16.9088 19.2566 16.1991 19.3663 15.5069 19.2549C14.8147 19.1436 14.1752 18.8167 13.6794 18.321C13.1837 17.8252 12.8569 17.1857 12.7455 16.4935C12.6341 15.8013 12.7438 15.0916 13.059 14.4653C13.3742 13.8391 13.8789 13.3281 14.5012 13.0052C15.1236 12.6823 15.8319 12.5638 16.5254 12.6667C17.2328 12.7716 17.8878 13.1012 18.3935 13.6069C18.8992 14.1126 19.2288 14.7676 19.3337 15.475Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.583 11.4167H20.5913",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsta);
export default __webpack_public_path__ + "static/media/icon-insta.8a3662af5b8eba98c8ae957f8b364723.svg";
export { ForwardRef as ReactComponent };